import React from "react";
import "./Heading_Holder.css";

function Heading_Holder({ headingText, subtext }) {
  return (
    <>
      <section className="Heading_Holder">
        <h3 className="font-use">{headingText}</h3>
        <h5 className="font-use">{subtext}</h5>
      </section>
    </>
  );
}

export default Heading_Holder;
